<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="26.021" height="13.96" viewBox="0 0 26.021 13.96">
    <g transform="translate(-694.979 -844.439)">
      <g transform="translate(308.732 449.485)">
        <g transform="translate(386.247 394.954)">
          <path
            d="M407.156,408.914H386.247l.033-.622a65.576,65.576,0,0,1,1.328-10.108l.6.035.229-.168a4.817,4.817,0,0,0,1.122.987c.7.516,2.1-.35,2.833-.927l-1.04-3.157.974.443a48.467,48.467,0,0,1,5.524,2.967,19.246,19.246,0,0,0,4.554,1.822,14.706,14.706,0,0,1,3.908,1.576c2.034,1.464.984,6.509.938,6.722Zm-19.935-1.166h19.23c.244-1.435.474-4.208-.592-4.971a14.491,14.491,0,0,0-3.671-1.458,19.738,19.738,0,0,1-4.745-1.911A48.374,48.374,0,0,0,393,396.96l.527,1.586-.3.271c-.269.233-2.658,2.318-4.116,1.234-.342-.252-.605-.466-.808-.646a64.033,64.033,0,0,0-1.072,8.342Z"
            transform="translate(-386.247 -394.954)"
            fill="#777"
          />
          <rect
            width="20.313"
            height="1.144"
            transform="translate(0.661 9.95)"
            fill="#777"
          />
          <rect
            width="3.155"
            height="1.142"
            transform="translate(8.655 5.734) rotate(-60.477)"
            fill="#777"
          />
          <rect
            width="2.841"
            height="1.144"
            transform="matrix(0.512, -0.859, 0.859, 0.512, 10.521, 6.588)"
            fill="#777"
          />
        </g>
      </g>
      <rect
        width="1"
        height="6"
        transform="translate(720 852)"
        fill="#777"
      />
      <rect
        width="3"
        height="1"
        transform="translate(718 852)"
        fill="#777"
      />
      <rect
        width="3"
        height="1"
        transform="translate(718 857)"
        fill="#777"
      />
    </g>
  </svg>
</template>
